// extracted by mini-css-extract-plugin
export default {"section":"rHBxja","infoContainer":"sjA3Mw","buttonContainer":"QsDrxR"};